import { AIResponseMessage } from 'features/chatbot/components/AIResponseMessage'
import { AIResponseExtras } from 'features/chatbot/components/conversationMessage/AIResponseExtras'
import {
  ErrorMessage,
  MessageRow,
} from 'features/chatbot/components/conversationMessage/styles'
import { UserMessage } from 'features/chatbot/components/conversationMessage/UserMessage'
import { FeedbackMenuWrapper } from 'features/chatbot/components/FeedbackMenu'
import { buildMessageFeedbackKey } from 'features/chatbot/contexts/ChatbotFeedbackContext'
import { ConversationMessage } from 'features/chatbot/types/conversation'
import React from 'react'

interface ConversationMessageComponentProps {
  message: ConversationMessage
  itemIndex: number
  isLastUserMessage?: boolean
}

export const ConversationMessageComponent: React.FC<
  ConversationMessageComponentProps
> = ({ message, itemIndex, isLastUserMessage = false }) => {
  const isUser = message.type === 'userMessage'

  let messageContent: React.ReactNode

  switch (message.type) {
    case 'userMessage':
      messageContent = (
        <UserMessage
          text={message.text}
          itemIndex={itemIndex}
          isLastUserMessage={isLastUserMessage}
        />
      )
      break
    case 'error':
      messageContent = <ErrorMessage>{message.text}</ErrorMessage>
      break
    case 'aiResponse': {
      const feedbackTarget = {
        key: buildMessageFeedbackKey(message.messageId, itemIndex),
        messageId: message.messageId,
        messageIndex: itemIndex,
      }
      messageContent =
        message.naturalLanguageResponseBySegments &&
        message.naturalLanguageResponseBySegments.length > 0 ? (
          <>
            <FeedbackMenuWrapper target={feedbackTarget}>
              <AIResponseMessage
                segments={message.naturalLanguageResponseBySegments}
              />
            </FeedbackMenuWrapper>
            <AIResponseExtras
              sources={message.sources}
              instrumentsWithData={message.instrumentsWithData}
              thinkingTimeSeconds={message.thinkingTimeSeconds}
              thinkingNotes={message.thinkingNotes}
              messageId={message.messageId}
              messageIndex={itemIndex}
            />
          </>
        ) : (
          <ErrorMessage>No response from AI</ErrorMessage>
        )
      break
    }
  }

  return (
    <MessageRow key={itemIndex} $isUser={isUser}>
      {messageContent}
    </MessageRow>
  )
}
